/**
 * Separates the two drill-down stacks kept in one URL (`/a/b/~/c/d`). Lives
 * here so leaf modules (access checks, the router, demos) share one value
 * without importing the app-level router.
 */
export const STACK_SEPARATOR = '/~';
